import { AUTH_PATH, BUBBLETAP_PATH, CHAT_PATH, CONTEST_PATH } from './commonWebServicePath';

export const BUBBLECHAT_WEB_PATH = {
  AUTH: AUTH_PATH,
  WEB: BUBBLETAP_PATH,
  CHAT: CHAT_PATH,
  CONTEST: CONTEST_PATH,
};
